__turbopack_context__.v({
  "actionBtn": "history-module__uUdKIq__actionBtn",
  "actionButtons": "history-module__uUdKIq__actionButtons",
  "container": "history-module__uUdKIq__container",
  "continueBtn": "history-module__uUdKIq__continueBtn",
  "deleteBtn": "history-module__uUdKIq__deleteBtn",
  "emptyState": "history-module__uUdKIq__emptyState",
  "error": "history-module__uUdKIq__error",
  "formats": "history-module__uUdKIq__formats",
  "header": "history-module__uUdKIq__header",
  "matchBtn": "history-module__uUdKIq__matchBtn",
  "pauseBtn": "history-module__uUdKIq__pauseBtn",
  "progressBar": "history-module__uUdKIq__progressBar",
  "progressFill": "history-module__uUdKIq__progressFill",
  "progressSection": "history-module__uUdKIq__progressSection",
  "progressText": "history-module__uUdKIq__progressText",
  "scanActions": "history-module__uUdKIq__scanActions",
  "scanContent": "history-module__uUdKIq__scanContent",
  "scanFilename": "history-module__uUdKIq__scanFilename",
  "scanIcon": "history-module__uUdKIq__scanIcon",
  "scanId": "history-module__uUdKIq__scanId",
  "scanItem": "history-module__uUdKIq__scanItem",
  "scanMeta": "history-module__uUdKIq__scanMeta",
  "scanStatus": "history-module__uUdKIq__scanStatus",
  "scansCard": "history-module__uUdKIq__scansCard",
  "scansList": "history-module__uUdKIq__scansList",
  "searchBox": "history-module__uUdKIq__searchBox",
  "searchInput": "history-module__uUdKIq__searchInput",
  "searchSection": "history-module__uUdKIq__searchSection",
  "spin": "history-module__uUdKIq__spin",
  "statBadge": "history-module__uUdKIq__statBadge",
  "stats": "history-module__uUdKIq__stats",
  "statusBadge": "history-module__uUdKIq__statusBadge",
  "stopBtn": "history-module__uUdKIq__stopBtn",
  "subtitle": "history-module__uUdKIq__subtitle",
  "success": "history-module__uUdKIq__success",
  "timeRemaining": "history-module__uUdKIq__timeRemaining",
  "title": "history-module__uUdKIq__title",
  "uploadArea": "history-module__uUdKIq__uploadArea",
  "uploadBtn": "history-module__uUdKIq__uploadBtn",
  "uploadCard": "history-module__uUdKIq__uploadCard",
  "uploadIcon": "history-module__uUdKIq__uploadIcon",
  "uploadStatus": "history-module__uUdKIq__uploadStatus",
  "uploading": "history-module__uUdKIq__uploading",
  "viewBtn": "history-module__uUdKIq__viewBtn",
});
